import { render, staticRenderFns } from "./toPageKnowledge.vue?vue&type=template&id=8c5fd5ec&scoped=true"
import script from "./toPageKnowledge.vue?vue&type=script&lang=js"
export * from "./toPageKnowledge.vue?vue&type=script&lang=js"
import style0 from "./toPageKnowledge.vue?vue&type=style&index=0&id=8c5fd5ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5fd5ec",
  null
  
)

export default component.exports